import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import DashIcon from '@/components/icons/DashIcon.vue'
import MagnifyIcon from '@/components/icons/MagnifyIcon.vue'
import DBIcon from '@/components/icons/DBIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import BellIcon from '@/components/icons/BellIcon.vue'
Vue.use(Vuetify);


export default new Vuetify({
  theme: { 
    light: true, 
    options: {
      customProperties: true,
    },  
    themes: {
      light: {
        primary: '#42DEFA',
        darkgreen: '#009f89',
        secondary: 'white',
        background: '#ececec',
        gradient1: 'rgb(66, 222, 250, 0.8)',
        gradient2: 'rgb(66, 222, 250, 0.3)',
        gradient3: 'rgb(66, 222, 250, 0)',
        sparklineGradient1:  '#36AEFF',
        sparklineGradient2:  '#00FFFB',
        sparklineGradient3:  'rgb(255, 255, 255, 0)',
      },     
      // light: {
      //   primary: '#1cedb2',
      //   darkgreen: '#009f89',
      //   secondary: 'white',
      //   background: '#ececec',
      //   gradient1: 'rgb(28, 237, 178, 0.8)',
      //   gradient2: 'rgb(28, 237, 178, 0.3)',
      //   gradient3: 'rgb(28, 237, 178, 0)',
      //   sparklineGradient1:  '#65bd9f',
      //   sparklineGradient2:  '#6bffce',
      //   sparklineGradient3:  'rgb(255, 255, 255, 0)',
      // },
      dark:{
        primary: '#1cedb2',
        secondary: 'white',
        background: '#454545',
        gradient1: 'rgb(28, 237, 178, 0.8)',
        gradient2: 'rgb(28, 237, 178, 0.3)',
        gradient3: 'rgb(28, 237, 178, 0)',
        sparklineGradient1:  '#65bd9f',
        sparklineGradient2:  '#6bffce',
        sparklineGradient3:  'rgb(255, 255, 255, 0)',
      }
    }
  },//#ff5630 rot 1 #ff3b0f rot 2  #fa0cee lila #e655de lila 2 #e83174 lila 3 #16d964 grün
  icons: {
    values: {
      dashboard: { // name of our custom icon
        component: DashIcon, // our custom component
      },
      magnify: { // name of our custom icon
        component: MagnifyIcon, // our custom component
      },
      database: { // name of our custom icon
        component: DBIcon, // our custom component
      },
      logout: { // name of our custom icon
        component: LogoutIcon, // our custom component
      },
      bell: { // name of our custom icon
        component: BellIcon, // our custom component
      },
    },
  },
})